import { ISignOverview } from '../../../functions/src/shared/contracts/api/GlossContract';
import { Label } from '../../../functions/src/shared/contracts/Label';

export function sortGroup(glossA: ISignOverview, glossB: ISignOverview) {
    const aHasLabels = glossA.labels && glossA.labels.length > 0;
    const bHasLabels = glossB.labels && glossB.labels.length > 0;
    const aHasVlaanderen = glossA.regions.includes('Vlaanderen');
    const bHasVlaanderen = glossB.regions.includes('Vlaanderen');

    // Glosses without labels should come before glosses with labels
    if (!aHasLabels && bHasLabels) return -1;
    if (!bHasLabels && aHasLabels) return 1;

    // Flanders should come before regional glosses
    if (aHasVlaanderen && !bHasVlaanderen) return -1;
    if (bHasVlaanderen && !aHasVlaanderen) return 1;

    // Sorting by label priority
    if (aHasLabels && bHasLabels) {
        return sortByLabels(glossA, glossB);
    }

    return 0;
}

export function sortByLabels(glossA: ISignOverview, glossB: ISignOverview) {
    const LABEL_PRIORITY: string[] = [
        Label.Recent,
        Label.Neologism,
        Label.Negative,
        Label.Explicit,
        Label.Offensive,
        Label.Outdated,
    ];

    const aLabelPriorities = glossA.labels
        .map((label) => LABEL_PRIORITY.indexOf(label))
        .filter((index) => index !== -1)
        .sort(sortNumbers);
    const bLabelPriorities = glossB.labels
        .map((label) => LABEL_PRIORITY.indexOf(label))
        .filter((index) => index !== -1)
        .sort(sortNumbers);

    const maxLabels = Math.max(aLabelPriorities.length, bLabelPriorities.length);

    for (let i = 0; i < maxLabels; i++) {
        if (i >= bLabelPriorities.length) return 1;
        if (i >= aLabelPriorities.length) return -1;

        const aPrio = aLabelPriorities[i];
        const bPrio = bLabelPriorities[i];
        if (aPrio !== bPrio) {
            return aPrio - bPrio;
        }
    }
    return 0;
}

function sortNumbers(a: number, b: number) {
    return a - b;
}

function groupSearchResultsByGlossName(searchResults: ISignOverview[]) {
    const groupedResults: Record<string, ISignOverview[]> = {};
    searchResults.forEach((item) => {
        if (!groupedResults[item.glossName]) {
            groupedResults[item.glossName] = [];
        }
        groupedResults[item.glossName].push(item);
    });
    return groupedResults;
}

export function sortSearchResults(searchResults: ISignOverview[]) {
    const glossNameGroups = groupSearchResultsByGlossName(searchResults);
    Object.keys(glossNameGroups).forEach((glossName) => {
        glossNameGroups[glossName].sort(sortGroup);
    });
    return glossNameGroups;
}
